import { ComponentPropsWithoutRef } from 'react';

export function Code401(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="876" height="1080" viewBox="0 0 876 1080" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M278.709 597.227V631.924H244.754V690H208.016V631.924H74.6074V607.246L171.092 423.926H212.098L120.623 597.227H208.016V515.215H244.754V597.227H278.709Z"
        fill="#9E8AD9"
      />
      <path
        d="M440.978 688.605C419.34 688.585 398.06 682.95 379.123 672.227C360.186 661.504 344.21 646.04 332.684 627.28C321.159 608.52 314.46 587.075 313.213 564.946C311.966 542.816 316.211 520.723 325.553 500.729C326.285 499.151 327.599 497.934 329.205 497.347C330.812 496.761 332.581 496.851 334.123 497.599C335.664 498.347 336.853 499.692 337.428 501.338C338.002 502.983 337.916 504.795 337.187 506.375C329.624 522.298 325.747 539.792 325.859 557.5C325.859 580.9 332.636 603.774 345.333 623.226C358.03 642.678 376.075 657.834 397.184 666.774C418.293 675.714 441.516 678.038 463.915 673.45C486.314 668.862 506.88 657.569 523.01 641.001C539.14 624.432 550.109 603.334 554.528 580.376C558.947 557.418 556.618 533.633 547.834 512.032C539.051 490.431 524.21 471.985 505.188 459.03C486.166 446.074 463.82 439.192 440.978 439.254C417.914 439.113 395.364 446.229 376.377 459.642C374.956 460.598 373.222 460.937 371.557 460.584C369.892 460.231 368.432 459.215 367.498 457.76C366.564 456.304 366.233 454.528 366.577 452.822C366.922 451.116 367.914 449.62 369.335 448.664C388.615 435.413 411.045 427.775 434.233 426.565C457.419 425.354 480.492 430.617 500.986 441.791C521.481 452.965 538.629 469.632 550.6 490.01C562.572 510.389 568.916 533.715 568.955 557.5C568.867 592.243 555.355 625.537 531.374 650.104C507.392 674.672 474.893 688.514 440.978 688.605Z"
        fill="#9E8AD9"
      />
      <path
        d="M440.96 660.695C421.038 660.695 401.563 654.643 384.998 643.304C368.433 631.965 355.523 615.849 347.899 596.994C340.275 578.138 338.28 557.39 342.167 537.373C346.053 517.356 355.647 498.969 369.734 484.537C383.821 470.106 401.769 460.278 421.309 456.296C440.848 452.315 461.102 454.358 479.507 462.168C497.913 469.979 513.645 483.205 524.713 500.174C535.782 517.144 541.689 537.095 541.689 557.504C541.691 558.37 541.526 559.228 541.203 560.029C540.881 560.83 540.408 561.557 539.81 562.17C539.213 562.783 538.504 563.269 537.723 563.601C536.942 563.933 536.105 564.104 535.259 564.104C534.414 564.104 533.577 563.933 532.796 563.601C532.016 563.269 531.306 562.783 530.709 562.17C530.111 561.557 529.638 560.83 529.315 560.029C528.993 559.228 528.829 558.37 528.83 557.504C528.83 539.701 523.676 522.296 514.021 507.493C504.366 492.69 490.643 481.152 474.587 474.339C458.53 467.526 440.863 465.743 423.817 469.216C406.772 472.69 391.116 481.263 378.827 493.852C366.538 506.441 358.169 522.481 354.779 539.943C351.388 557.404 353.128 575.503 359.779 591.952C366.43 608.401 377.692 622.459 392.142 632.351C406.592 642.242 423.581 647.522 440.96 647.522C455.377 647.588 469.584 643.983 482.303 637.029C495.022 630.076 505.855 619.993 513.828 607.688C514.29 606.967 514.887 606.346 515.583 605.862C516.279 605.377 517.063 605.037 517.887 604.863C518.712 604.688 519.561 604.681 520.388 604.844C521.215 605.005 522.003 605.332 522.707 605.806C523.41 606.28 524.016 606.891 524.489 607.604C524.962 608.317 525.294 609.12 525.464 609.964C525.635 610.809 525.641 611.679 525.484 612.527C525.325 613.374 525.006 614.18 524.544 614.902C515.356 628.981 502.923 640.525 488.345 648.512C473.766 656.498 457.492 660.683 440.96 660.695Z"
        fill="#9E8AD9"
      />
      <path
        d="M440.973 633.085C431.285 633.127 421.687 631.177 412.747 627.353C403.807 623.528 395.706 617.905 388.924 610.817C378.626 600.234 371.613 586.766 368.769 572.109C365.925 557.453 367.376 542.262 372.94 528.447C378.504 514.634 387.932 502.815 400.038 494.477C412.143 486.14 426.386 481.657 440.973 481.593C450.662 481.552 460.259 483.501 469.2 487.326C478.14 491.151 486.24 496.774 493.022 503.862C493.604 504.46 494.067 505.169 494.383 505.949C494.698 506.729 494.86 507.566 494.86 508.41C494.86 509.255 494.698 510.091 494.383 510.872C494.067 511.652 493.604 512.361 493.022 512.958C492.439 513.556 491.746 514.029 490.984 514.352C490.222 514.676 489.406 514.842 488.582 514.842C487.757 514.842 486.941 514.676 486.179 514.352C485.418 514.029 484.726 513.555 484.143 512.958C478.484 507.145 471.753 502.542 464.342 499.419C456.93 496.296 448.987 494.714 440.973 494.767C424.813 494.806 409.313 501.338 397.803 512.958C389.247 521.688 383.416 532.825 381.051 544.957C378.685 557.088 379.892 569.666 384.518 581.092C389.144 592.52 396.98 602.281 407.032 609.137C417.083 615.993 428.897 619.634 440.973 619.599C449.975 619.623 458.871 617.605 467.022 613.688C475.172 609.772 482.375 604.055 488.111 596.948C493.849 589.841 497.978 581.521 500.204 572.584C502.429 563.648 502.694 554.318 500.981 545.264C500.819 544.44 500.817 543.591 500.975 542.765C501.134 541.94 501.449 541.156 501.905 540.456C502.359 539.755 502.944 539.154 503.626 538.686C504.308 538.218 505.073 537.891 505.878 537.727C506.683 537.561 507.512 537.561 508.318 537.725C509.122 537.888 509.888 538.213 510.571 538.68C511.254 539.147 511.84 539.747 512.296 540.447C512.751 541.145 513.069 541.93 513.228 542.755C515.568 554.879 514.949 567.407 511.423 579.226C507.898 591.046 501.576 601.79 493.022 610.503C486.298 617.692 478.215 623.402 469.266 627.285C460.318 631.167 450.691 633.141 440.973 633.085Z"
        fill="#9E8AD9"
      />
      <path
        d="M440.966 602.043C432.401 602.079 424.019 599.505 416.886 594.649C409.754 589.792 404.192 582.871 400.91 574.767C397.627 566.664 396.772 557.742 398.453 549.139C400.134 540.535 404.275 532.639 410.349 526.453C411.526 525.247 413.123 524.569 414.788 524.569C416.454 524.569 418.05 525.247 419.227 526.453C420.405 527.659 421.066 529.296 421.066 531.001C421.066 532.706 420.405 534.343 419.227 535.549C414.133 540.875 411.071 547.895 410.596 555.337C410.122 562.779 412.266 570.148 416.641 576.108C421.016 582.068 427.331 586.224 434.441 587.823C441.551 589.421 448.985 588.356 455.395 584.821C461.804 581.286 466.764 575.514 469.374 568.553C471.986 561.592 472.074 553.903 469.626 546.881C467.177 539.858 462.352 533.967 456.026 530.277C449.701 526.587 442.293 525.341 435.149 526.767C433.525 527.096 431.842 526.752 430.466 525.811C429.091 524.87 428.136 523.408 427.812 521.746C427.487 520.084 427.819 518.359 428.736 516.948C429.652 515.537 431.078 514.556 432.7 514.221C438.629 513.018 444.739 513.101 450.636 514.465C456.532 515.829 462.084 518.443 466.935 522.14C471.784 525.836 475.825 530.532 478.795 535.925C481.766 541.319 483.599 547.29 484.181 553.454C484.761 559.618 484.073 565.839 482.164 571.714C480.254 577.59 477.165 582.99 473.093 587.568C469.022 592.145 464.06 595.798 458.526 598.291C452.993 600.784 447.01 602.062 440.966 602.043Z"
        fill="#9E8AD9"
      />
      <path d="M706.881 423.926V690H670.143V474.209L609.654 524.678V480.332L681.09 423.926H706.881Z" fill="#9E8AD9" />
      <g filter="url(#filter0_d_2361_6810)">
        <path
          d="M438.496 755.515C548.674 755.515 637.881 666.637 637.746 557C637.61 447.363 548.183 358.485 438.005 358.485C327.827 358.485 238.62 447.363 238.755 557C238.891 666.637 328.318 755.515 438.496 755.515Z"
          fill="#F2F0FF"
          fillOpacity="0.13"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2361_6810)">
        <path
          d="M0 646.5C0 629.931 13.4315 616.5 30 616.5H112C128.569 616.5 142 629.931 142 646.5V678.5H30C13.4315 678.5 0 665.069 0 648.5V646.5Z"
          fill="url(#paint0_linear_2361_6810)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_d_2361_6810)">
        <path
          d="M648 792.5H756C773.121 792.5 787 806.379 787 823.5C787 840.621 773.121 854.5 756 854.5H688C665.909 854.5 648 836.591 648 814.5V792.5Z"
          fill="url(#paint1_linear_2361_6810)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter3_d_2361_6810)">
        <path
          d="M518 280.5C518 263.931 531.431 250.5 548 250.5H674C690.569 250.5 704 263.931 704 280.5V282.5C704 299.069 690.569 312.5 674 312.5H518V280.5Z"
          fill="url(#paint2_linear_2361_6810)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <mask id="path-11-inside-1_2361_6810" fill="white">
        <path d="M600.176 504.376C602.277 503.694 604.538 504.844 605.171 506.96C612.294 530.754 614.255 555.795 610.923 580.408C610.627 582.597 608.572 584.084 606.39 583.738L543.632 573.773C541.45 573.426 539.97 571.377 540.232 569.184C541.835 555.73 540.767 542.091 537.089 529.051C536.489 526.925 537.632 524.671 539.733 523.989L600.176 504.376Z" />
      </mask>
      <path
        d="M600.176 504.376C602.277 503.694 604.538 504.844 605.171 506.96C612.294 530.754 614.255 555.795 610.923 580.408C610.627 582.597 608.572 584.084 606.39 583.738L543.632 573.773C541.45 573.426 539.97 571.377 540.232 569.184C541.835 555.73 540.767 542.091 537.089 529.051C536.489 526.925 537.632 524.671 539.733 523.989L600.176 504.376Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-11-inside-1_2361_6810)"
      />
      <mask id="path-12-inside-2_2361_6810" fill="white">
        <path d="M606.442 583.41C608.625 583.752 610.121 585.8 609.729 587.974C605.321 612.416 595.745 635.637 581.642 656.082C580.388 657.9 577.883 658.298 576.093 657.002L524.626 619.732C522.837 618.436 522.444 615.939 523.669 614.101C531.184 602.827 536.399 590.18 539.016 576.886C539.443 574.719 541.482 573.225 543.664 573.567L606.442 583.41Z" />
      </mask>
      <path
        d="M606.442 583.41C608.625 583.752 610.121 585.8 609.729 587.974C605.321 612.416 595.745 635.637 581.642 656.082C580.388 657.9 577.883 658.298 576.093 657.002L524.626 619.732C522.837 618.436 522.444 615.939 523.669 614.101C531.184 602.827 536.399 590.18 539.016 576.886C539.443 574.719 541.482 573.225 543.664 573.567L606.442 583.41Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-12-inside-2_2361_6810)"
      />
      <mask id="path-13-inside-3_2361_6810" fill="white">
        <path d="M576.066 657.041C577.854 658.337 578.257 660.841 576.921 662.6C561.89 682.373 542.812 698.71 520.961 710.518C519.018 711.568 516.605 710.784 515.6 708.817L486.679 652.235C485.673 650.268 486.457 647.865 488.384 646.784C500.199 640.154 510.59 631.256 518.96 620.602C520.325 618.864 522.82 618.46 524.609 619.756L576.066 657.041Z" />
      </mask>
      <path
        d="M576.066 657.041C577.854 658.337 578.257 660.841 576.921 662.6C561.89 682.373 542.812 698.71 520.961 710.518C519.018 711.568 516.605 710.784 515.6 708.817L486.679 652.235C485.673 650.268 486.457 647.865 488.384 646.784C500.199 640.154 510.59 631.256 518.96 620.602C520.325 618.864 522.82 618.46 524.609 619.756L576.066 657.041Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-13-inside-3_2361_6810)"
      />
      <mask id="path-14-inside-4_2361_6810" fill="white">
        <path d="M516.139 708.54C517.152 710.504 516.383 712.921 514.396 713.888C492.066 724.762 467.671 730.743 442.844 731.433C440.636 731.494 438.836 729.707 438.825 727.498L438.517 663.954C438.507 661.745 440.29 659.953 442.497 659.857C456.033 659.265 469.319 656.007 481.594 650.27C483.595 649.335 486.005 650.098 487.017 652.062L516.139 708.54Z" />
      </mask>
      <path
        d="M516.139 708.54C517.152 710.504 516.383 712.921 514.396 713.888C492.066 724.762 467.671 730.743 442.844 731.433C440.636 731.494 438.836 729.707 438.825 727.498L438.517 663.954C438.507 661.745 440.29 659.953 442.497 659.857C456.033 659.265 469.319 656.007 481.594 650.27C483.595 649.335 486.005 650.098 487.017 652.062L516.139 708.54Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-14-inside-4_2361_6810)"
      />
      <path
        d="M531.967 440.357C531.208 441.379 530.243 441.973 529.073 442.141C527.899 442.305 526.825 442.025 525.85 441.301C524.874 440.576 524.298 439.63 524.12 438.461C523.942 437.292 524.233 436.197 524.992 435.175C525.456 434.551 526.028 434.091 526.711 433.795C527.395 433.495 528.096 433.393 528.814 433.488L528.718 434.344C528.149 434.252 527.587 434.324 527.033 434.56C526.479 434.795 526.016 435.162 525.646 435.66C525.021 436.501 524.783 437.392 524.93 438.333C525.08 439.272 525.553 440.037 526.349 440.628C527.146 441.22 528.015 441.452 528.956 441.324C529.898 441.197 530.682 440.711 531.309 439.867C531.681 439.366 531.902 438.817 531.97 438.22C532.036 437.621 531.941 437.065 531.686 436.549L532.464 436.2C532.767 436.853 532.876 437.555 532.791 438.304C532.705 439.049 532.431 439.733 531.967 440.357ZM535.864 434.865L527.666 431.811L528.197 431.096L535.262 433.76L530.738 427.677L531.325 426.886L538.455 429.461L533.865 423.467L534.396 422.752L539.687 429.719L539.086 430.528L531.92 427.942L536.465 434.056L535.864 434.865ZM541.792 425.56L544.227 422.282L544.862 422.753L541.927 426.704L535.182 421.694L538.079 417.795L538.719 418.27L536.322 421.496L538.706 423.268L540.925 420.281L541.565 420.756L539.346 423.743L541.792 425.56ZM543.055 419.615L542.439 419.157L545.014 415.691L545.63 416.149L543.055 419.615ZM543.554 410.424L543.981 409.85L550.725 414.861L550.226 415.534L544.224 411.075L543.554 412.92L542.846 412.665L543.554 410.424ZM551.585 413.704L550.978 413.253L550.335 409.009C550.157 407.801 549.82 407.014 549.325 406.645C548.895 406.326 548.461 406.21 548.021 406.297C547.582 406.385 547.224 406.615 546.946 406.988C546.432 407.681 546.376 408.421 546.78 409.207L546.018 409.525C545.76 409.002 545.659 408.479 545.716 407.957C545.772 407.429 545.964 406.944 546.293 406.502C546.693 405.963 547.227 405.625 547.894 405.487C548.559 405.344 549.204 405.505 549.828 405.968C550.22 406.259 550.515 406.649 550.712 407.136C550.907 407.621 551.055 408.211 551.158 408.905L551.647 412.254L554.114 408.933L554.768 409.419L551.585 413.704ZM556.9 402.404L557.534 402.876L556.888 403.746L558.238 404.749L557.738 405.421L556.388 404.418L553.74 407.984L553.105 407.512L550.207 401.469L550.756 400.73L553.657 406.769L555.753 403.947L553.693 402.416L554.193 401.744L556.253 403.274L556.9 402.404Z"
        fill="#FBFDFF"
      />
      <path
        d="M438 457.5C438 455.291 439.792 453.492 441.999 453.577C462.446 454.368 482.233 461.204 498.836 473.267C515.438 485.329 528.055 502.036 535.125 521.237C535.888 523.31 534.731 525.57 532.63 526.253L499.88 536.894C497.779 537.576 495.535 536.42 494.716 534.369C490.453 523.683 483.245 514.392 473.893 507.597C464.542 500.803 453.477 496.819 441.997 496.066C439.793 495.921 438 494.144 438 491.935L438 457.5Z"
        fill="#9E8AD9"
        stroke="#483389"
      />
      <mask id="path-17-inside-5_2361_6810" fill="white">
        <path d="M532.591 526.133C534.691 525.448 536.957 526.593 537.561 528.718C541.651 543.116 542.574 558.245 540.246 573.062C537.711 589.197 531.394 604.504 521.81 617.73C512.226 630.956 499.648 641.726 485.104 649.16C471.749 655.986 457.085 659.82 442.13 660.418C439.922 660.506 438.128 658.709 438.126 656.5L438.082 622.065C438.079 619.856 439.87 618.076 442.074 617.929C450.329 617.377 458.4 615.152 465.792 611.374C474.372 606.988 481.793 600.634 487.448 592.831C493.102 585.027 496.83 575.997 498.325 566.477C499.613 558.276 499.214 549.913 497.168 541.897C496.622 539.757 497.755 537.501 499.855 536.816L532.591 526.133Z" />
      </mask>
      <path
        d="M532.591 526.133C534.691 525.448 536.957 526.593 537.561 528.718C541.651 543.116 542.574 558.245 540.246 573.062C537.711 589.197 531.394 604.504 521.81 617.73C512.226 630.956 499.648 641.726 485.104 649.16C471.749 655.986 457.085 659.82 442.13 660.418C439.922 660.506 438.128 658.709 438.126 656.5L438.082 622.065C438.079 619.856 439.87 618.076 442.074 617.929C450.329 617.377 458.4 615.152 465.792 611.374C474.372 606.988 481.793 600.634 487.448 592.831C493.102 585.027 496.83 575.997 498.325 566.477C499.613 558.276 499.214 549.913 497.168 541.897C496.622 539.757 497.755 537.501 499.855 536.816L532.591 526.133Z"
        fill="#9E8AD9"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-17-inside-5_2361_6810)"
      />
      <mask
        id="mask0_2361_6810"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="245"
        y="211"
        width="603"
        height="4"
      >
        <circle cx="846" cy="213.241" r="1.5" transform="rotate(-180 846 213.241)" fill="#F24C84" />
        <circle cx="837.906" cy="213.241" r="1.5" transform="rotate(-180 837.906 213.241)" fill="#F24C84" />
        <circle cx="829.811" cy="213.241" r="1.5" transform="rotate(-180 829.811 213.241)" fill="#F24C84" />
        <circle cx="821.716" cy="213.241" r="1.5" transform="rotate(-180 821.716 213.241)" fill="#F24C84" />
        <circle cx="813.622" cy="213.241" r="1.5" transform="rotate(-180 813.622 213.241)" fill="#F24C84" />
        <circle cx="805.527" cy="213.241" r="1.5" transform="rotate(-180 805.527 213.241)" fill="#F24C84" />
        <circle cx="797.432" cy="213.241" r="1.5" transform="rotate(-180 797.432 213.241)" fill="#F24C84" />
        <circle cx="789.338" cy="213.241" r="1.5" transform="rotate(-180 789.338 213.241)" fill="#F24C84" />
        <circle cx="781.243" cy="213.241" r="1.5" transform="rotate(-180 781.243 213.241)" fill="#F24C84" />
        <circle cx="773.149" cy="213.241" r="1.5" transform="rotate(-180 773.149 213.241)" fill="#F24C84" />
        <circle cx="765.054" cy="213.241" r="1.5" transform="rotate(-180 765.054 213.241)" fill="#F24C84" />
        <circle cx="756.959" cy="213.241" r="1.5" transform="rotate(-180 756.959 213.241)" fill="#F24C84" />
        <circle cx="748.865" cy="213.241" r="1.5" transform="rotate(-180 748.865 213.241)" fill="#F24C84" />
        <circle cx="740.77" cy="213.241" r="1.5" transform="rotate(-180 740.77 213.241)" fill="#F24C84" />
        <circle cx="732.676" cy="213.241" r="1.5" transform="rotate(-180 732.676 213.241)" fill="#F24C84" />
        <circle cx="724.581" cy="213.241" r="1.5" transform="rotate(-180 724.581 213.241)" fill="#F24C84" />
        <circle cx="716.487" cy="213.241" r="1.5" transform="rotate(-180 716.487 213.241)" fill="#F24C84" />
        <circle cx="708.392" cy="213.241" r="1.5" transform="rotate(-180 708.392 213.241)" fill="#F24C84" />
        <circle cx="700.297" cy="213.241" r="1.5" transform="rotate(-180 700.297 213.241)" fill="#F24C84" />
        <circle cx="692.203" cy="213.241" r="1.5" transform="rotate(-180 692.203 213.241)" fill="#F24C84" />
        <circle cx="684.108" cy="213.241" r="1.5" transform="rotate(-180 684.108 213.241)" fill="#F24C84" />
        <circle cx="676.013" cy="213.241" r="1.5" transform="rotate(-180 676.013 213.241)" fill="#F24C84" />
        <circle cx="667.919" cy="213.241" r="1.5" transform="rotate(-180 667.919 213.241)" fill="#F24C84" />
        <circle cx="659.824" cy="213.241" r="1.5" transform="rotate(-180 659.824 213.241)" fill="#F24C84" />
        <circle cx="651.73" cy="213.241" r="1.5" transform="rotate(-180 651.73 213.241)" fill="#F24C84" />
        <circle cx="643.635" cy="213.241" r="1.5" transform="rotate(-180 643.635 213.241)" fill="#F24C84" />
        <circle cx="635.541" cy="213.241" r="1.5" transform="rotate(-180 635.541 213.241)" fill="#F24C84" />
        <circle cx="627.446" cy="213.241" r="1.5" transform="rotate(-180 627.446 213.241)" fill="#F24C84" />
        <circle cx="619.351" cy="213.241" r="1.5" transform="rotate(-180 619.351 213.241)" fill="#F24C84" />
        <circle cx="611.257" cy="213.241" r="1.5" transform="rotate(-180 611.257 213.241)" fill="#F24C84" />
        <circle cx="603.162" cy="213.241" r="1.5" transform="rotate(-180 603.162 213.241)" fill="#F24C84" />
        <circle cx="595.068" cy="213.241" r="1.5" transform="rotate(-180 595.068 213.241)" fill="#F24C84" />
        <circle cx="586.973" cy="213.241" r="1.5" transform="rotate(-180 586.973 213.241)" fill="#F24C84" />
        <circle cx="578.878" cy="213.241" r="1.5" transform="rotate(-180 578.878 213.241)" fill="#F24C84" />
        <circle cx="570.784" cy="213.241" r="1.5" transform="rotate(-180 570.784 213.241)" fill="#F24C84" />
        <circle cx="562.689" cy="213.241" r="1.5" transform="rotate(-180 562.689 213.241)" fill="#F24C84" />
        <circle cx="554.595" cy="213.241" r="1.5" transform="rotate(-180 554.595 213.241)" fill="#F24C84" />
        <circle cx="546.5" cy="213.241" r="1.5" transform="rotate(-180 546.5 213.241)" fill="#F24C84" />
        <circle cx="538.406" cy="213.241" r="1.5" transform="rotate(-180 538.406 213.241)" fill="#F24C84" />
        <circle cx="530.311" cy="213.241" r="1.5" transform="rotate(-180 530.311 213.241)" fill="#F24C84" />
        <circle cx="522.216" cy="213.241" r="1.5" transform="rotate(-180 522.216 213.241)" fill="#F24C84" />
        <circle cx="514.122" cy="213.241" r="1.5" transform="rotate(-180 514.122 213.241)" fill="#F24C84" />
        <circle cx="506.027" cy="213.241" r="1.5" transform="rotate(-180 506.027 213.241)" fill="#F24C84" />
        <circle cx="497.932" cy="213.241" r="1.5" transform="rotate(-180 497.932 213.241)" fill="#F24C84" />
        <circle cx="489.838" cy="213.241" r="1.5" transform="rotate(-180 489.838 213.241)" fill="#F24C84" />
        <circle cx="481.743" cy="213.241" r="1.5" transform="rotate(-180 481.743 213.241)" fill="#F24C84" />
        <circle cx="473.649" cy="213.241" r="1.5" transform="rotate(-180 473.649 213.241)" fill="#F24C84" />
        <circle cx="465.554" cy="213.241" r="1.5" transform="rotate(-180 465.554 213.241)" fill="#F24C84" />
        <circle cx="457.459" cy="213.241" r="1.5" transform="rotate(-180 457.459 213.241)" fill="#F24C84" />
        <circle cx="449.365" cy="213.241" r="1.5" transform="rotate(-180 449.365 213.241)" fill="#F24C84" />
        <circle cx="441.27" cy="213.241" r="1.5" transform="rotate(-180 441.27 213.241)" fill="#F24C84" />
        <circle cx="433.176" cy="213.241" r="1.5" transform="rotate(-180 433.176 213.241)" fill="#F24C84" />
        <circle cx="425.081" cy="213.241" r="1.5" transform="rotate(-180 425.081 213.241)" fill="#F24C84" />
        <circle cx="416.986" cy="213.241" r="1.5" transform="rotate(-180 416.986 213.241)" fill="#F24C84" />
        <circle cx="408.892" cy="213.241" r="1.5" transform="rotate(-180 408.892 213.241)" fill="#F24C84" />
        <circle cx="400.797" cy="213.241" r="1.5" transform="rotate(-180 400.797 213.241)" fill="#F24C84" />
        <circle cx="392.703" cy="213.241" r="1.5" transform="rotate(-180 392.703 213.241)" fill="#F24C84" />
        <circle cx="384.608" cy="213.241" r="1.5" transform="rotate(-180 384.608 213.241)" fill="#F24C84" />
        <circle cx="376.513" cy="213.241" r="1.5" transform="rotate(-180 376.513 213.241)" fill="#F24C84" />
        <circle cx="368.419" cy="213.241" r="1.5" transform="rotate(-180 368.419 213.241)" fill="#F24C84" />
        <circle cx="360.324" cy="213.241" r="1.5" transform="rotate(-180 360.324 213.241)" fill="#F24C84" />
        <circle cx="352.229" cy="213.241" r="1.5" transform="rotate(-180 352.229 213.241)" fill="#F24C84" />
        <circle cx="344.135" cy="213.241" r="1.5" transform="rotate(-180 344.135 213.241)" fill="#F24C84" />
        <circle cx="336.04" cy="213.241" r="1.5" transform="rotate(-180 336.04 213.241)" fill="#F24C84" />
        <circle cx="327.946" cy="213.241" r="1.5" transform="rotate(-180 327.946 213.241)" fill="#F24C84" />
        <circle cx="319.851" cy="213.241" r="1.5" transform="rotate(-180 319.851 213.241)" fill="#F24C84" />
        <circle cx="311.757" cy="213.241" r="1.5" transform="rotate(-180 311.757 213.241)" fill="#F04586" />
        <circle cx="303.662" cy="213.241" r="1.5" transform="rotate(-180 303.662 213.241)" fill="#F04586" />
        <circle cx="295.567" cy="213.241" r="1.5" transform="rotate(-180 295.567 213.241)" fill="#F04586" />
        <circle cx="287.473" cy="213.241" r="1.5" transform="rotate(-180 287.473 213.241)" fill="#F04586" />
        <circle cx="279.378" cy="213.241" r="1.5" transform="rotate(-180 279.378 213.241)" fill="#F04586" />
        <circle cx="271.283" cy="213.241" r="1.5" transform="rotate(-180 271.283 213.241)" fill="#F04586" />
        <circle cx="263.189" cy="213.241" r="1.5" transform="rotate(-180 263.189 213.241)" fill="#F04586" />
        <circle cx="255.094" cy="213.241" r="1.5" transform="rotate(-180 255.094 213.241)" fill="#F04586" />
        <circle cx="247" cy="213.241" r="1.5" transform="rotate(-180 247 213.241)" fill="#F04586" />
      </mask>
      <g mask="url(#mask0_2361_6810)">
        <rect
          x="872.976"
          y="176.315"
          width="105.384"
          height="628.42"
          transform="rotate(90 872.976 176.315)"
          fill="url(#paint3_linear_2361_6810)"
        />
      </g>
      <mask
        id="mask1_2361_6810"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="696"
        y="410"
        width="4"
        height="726"
      >
        <circle cx="698.3" cy="412.019" r="1.5" transform="rotate(90 698.3 412.019)" fill="#F24C84" />
        <circle cx="698.3" cy="421.782" r="1.5" transform="rotate(90 698.3 421.782)" fill="#F24C84" />
        <circle cx="698.3" cy="431.545" r="1.5" transform="rotate(90 698.3 431.545)" fill="#F24C84" />
        <circle cx="698.3" cy="441.308" r="1.5" transform="rotate(90 698.3 441.308)" fill="#F24C84" />
        <circle cx="698.3" cy="451.072" r="1.5" transform="rotate(90 698.3 451.072)" fill="#F24C84" />
        <circle cx="698.3" cy="460.835" r="1.5" transform="rotate(90 698.3 460.835)" fill="#F24C84" />
        <circle cx="698.3" cy="470.598" r="1.5" transform="rotate(90 698.3 470.598)" fill="#F24C84" />
        <circle cx="698.3" cy="480.361" r="1.5" transform="rotate(90 698.3 480.361)" fill="#F24C84" />
        <circle cx="698.3" cy="490.125" r="1.5" transform="rotate(90 698.3 490.125)" fill="#F24C84" />
        <circle cx="698.3" cy="499.888" r="1.5" transform="rotate(90 698.3 499.888)" fill="#F24C84" />
        <circle cx="698.3" cy="509.651" r="1.5" transform="rotate(90 698.3 509.651)" fill="#F24C84" />
        <circle cx="698.3" cy="519.415" r="1.5" transform="rotate(90 698.3 519.415)" fill="#F24C84" />
        <circle cx="698.3" cy="529.178" r="1.5" transform="rotate(90 698.3 529.178)" fill="#F24C84" />
        <circle cx="698.3" cy="538.941" r="1.5" transform="rotate(90 698.3 538.941)" fill="#F24C84" />
        <circle cx="698.3" cy="548.704" r="1.5" transform="rotate(90 698.3 548.704)" fill="#F24C84" />
        <circle cx="698.3" cy="558.467" r="1.5" transform="rotate(90 698.3 558.467)" fill="#F24C84" />
        <circle cx="698.3" cy="568.23" r="1.5" transform="rotate(90 698.3 568.23)" fill="#F24C84" />
        <circle cx="698.3" cy="577.994" r="1.5" transform="rotate(90 698.3 577.994)" fill="#F24C84" />
        <circle cx="698.3" cy="587.757" r="1.5" transform="rotate(90 698.3 587.757)" fill="#F24C84" />
        <circle cx="698.3" cy="597.521" r="1.5" transform="rotate(90 698.3 597.521)" fill="#F24C84" />
        <circle cx="698.3" cy="607.284" r="1.5" transform="rotate(90 698.3 607.284)" fill="#F24C84" />
        <circle cx="698.3" cy="617.047" r="1.5" transform="rotate(90 698.3 617.047)" fill="#F24C84" />
        <circle cx="698.3" cy="626.81" r="1.5" transform="rotate(90 698.3 626.81)" fill="#F24C84" />
        <circle cx="698.3" cy="636.574" r="1.5" transform="rotate(90 698.3 636.574)" fill="#F24C84" />
        <circle cx="698.3" cy="646.337" r="1.5" transform="rotate(90 698.3 646.337)" fill="#F24C84" />
        <circle cx="698.3" cy="656.1" r="1.5" transform="rotate(90 698.3 656.1)" fill="#F24C84" />
        <circle cx="698.3" cy="665.863" r="1.5" transform="rotate(90 698.3 665.863)" fill="#F24C84" />
        <circle cx="698.3" cy="675.626" r="1.5" transform="rotate(90 698.3 675.626)" fill="#F24C84" />
        <circle cx="698.3" cy="685.39" r="1.5" transform="rotate(90 698.3 685.39)" fill="#F24C84" />
        <circle cx="698.3" cy="695.153" r="1.5" transform="rotate(90 698.3 695.153)" fill="#F24C84" />
        <circle cx="698.3" cy="704.917" r="1.5" transform="rotate(90 698.3 704.917)" fill="#F24C84" />
        <circle cx="698.3" cy="714.68" r="1.5" transform="rotate(90 698.3 714.68)" fill="#F24C84" />
        <circle cx="698.3" cy="724.443" r="1.5" transform="rotate(90 698.3 724.443)" fill="#F24C84" />
        <circle cx="698.3" cy="734.206" r="1.5" transform="rotate(90 698.3 734.206)" fill="#F24C84" />
        <circle cx="698.3" cy="743.969" r="1.5" transform="rotate(90 698.3 743.969)" fill="#F24C84" />
        <circle cx="698.3" cy="753.732" r="1.5" transform="rotate(90 698.3 753.732)" fill="#F24C84" />
        <circle cx="698.3" cy="763.496" r="1.5" transform="rotate(90 698.3 763.496)" fill="#F24C84" />
        <circle cx="698.3" cy="773.259" r="1.5" transform="rotate(90 698.3 773.259)" fill="#F24C84" />
        <circle cx="698.3" cy="783.022" r="1.5" transform="rotate(90 698.3 783.022)" fill="#F24C84" />
        <circle cx="698.3" cy="792.786" r="1.5" transform="rotate(90 698.3 792.786)" fill="#F24C84" />
        <circle cx="698.3" cy="802.549" r="1.5" transform="rotate(90 698.3 802.549)" fill="#F24C84" />
        <circle cx="698.3" cy="812.312" r="1.5" transform="rotate(90 698.3 812.312)" fill="#F24C84" />
        <circle cx="698.3" cy="822.075" r="1.5" transform="rotate(90 698.3 822.075)" fill="#F24C84" />
        <circle cx="698.3" cy="831.838" r="1.5" transform="rotate(90 698.3 831.838)" fill="#F24C84" />
        <circle cx="698.3" cy="841.602" r="1.5" transform="rotate(90 698.3 841.602)" fill="#F24C84" />
        <circle cx="698.3" cy="851.365" r="1.5" transform="rotate(90 698.3 851.365)" fill="#F24C84" />
        <circle cx="698.3" cy="861.128" r="1.5" transform="rotate(90 698.3 861.128)" fill="#F24C84" />
        <circle cx="698.3" cy="870.892" r="1.5" transform="rotate(90 698.3 870.892)" fill="#F24C84" />
        <circle cx="698.3" cy="880.655" r="1.5" transform="rotate(90 698.3 880.655)" fill="#F24C84" />
        <circle cx="698.3" cy="890.418" r="1.5" transform="rotate(90 698.3 890.418)" fill="#F24C84" />
        <circle cx="698.3" cy="900.181" r="1.5" transform="rotate(90 698.3 900.181)" fill="#F24C84" />
        <circle cx="698.3" cy="909.944" r="1.5" transform="rotate(90 698.3 909.944)" fill="#F24C84" />
        <circle cx="698.3" cy="919.708" r="1.5" transform="rotate(90 698.3 919.708)" fill="#F24C84" />
        <circle cx="698.3" cy="929.471" r="1.5" transform="rotate(90 698.3 929.471)" fill="#F24C84" />
        <circle cx="698.3" cy="939.234" r="1.5" transform="rotate(90 698.3 939.234)" fill="#F24C84" />
        <circle cx="698.3" cy="948.998" r="1.5" transform="rotate(90 698.3 948.998)" fill="#F24C84" />
        <circle cx="698.3" cy="958.761" r="1.5" transform="rotate(90 698.3 958.761)" fill="#F24C84" />
        <circle cx="698.3" cy="968.524" r="1.5" transform="rotate(90 698.3 968.524)" fill="#F24C84" />
        <circle cx="698.3" cy="978.287" r="1.5" transform="rotate(90 698.3 978.287)" fill="#F24C84" />
        <circle cx="698.3" cy="988.05" r="1.5" transform="rotate(90 698.3 988.05)" fill="#F24C84" />
        <circle cx="698.3" cy="997.813" r="1.5" transform="rotate(90 698.3 997.813)" fill="#F24C84" />
        <circle cx="698.3" cy="1007.58" r="1.5" transform="rotate(90 698.3 1007.58)" fill="#F24C84" />
        <circle cx="698.3" cy="1017.34" r="1.5" transform="rotate(90 698.3 1017.34)" fill="#F24C84" />
        <circle cx="698.3" cy="1027.1" r="1.5" transform="rotate(90 698.3 1027.1)" fill="#F24C84" />
        <circle cx="698.3" cy="1036.87" r="1.5" transform="rotate(90 698.3 1036.87)" fill="#F24C84" />
        <circle cx="698.3" cy="1046.63" r="1.5" transform="rotate(90 698.3 1046.63)" fill="#F24C84" />
        <circle cx="698.3" cy="1056.39" r="1.5" transform="rotate(90 698.3 1056.39)" fill="#F04586" />
        <circle cx="698.3" cy="1066.16" r="1.5" transform="rotate(90 698.3 1066.16)" fill="#F04586" />
        <circle cx="698.3" cy="1075.92" r="1.5" transform="rotate(90 698.3 1075.92)" fill="#F04586" />
      </mask>
      <g mask="url(#mask1_2361_6810)">
        <rect x="653.8" y="479.816" width="127" height="757.32" fill="url(#paint4_linear_2361_6810)" />
      </g>
      <mask
        id="mask2_2361_6810"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="771"
        y="-276"
        width="4"
        height="726"
      >
        <circle cx="773.3" cy="-1.12891" r="1.5" transform="rotate(90 773.3 -1.12891)" fill="#F24C84" />
        <circle cx="773.3" cy="8.63428" r="1.5" transform="rotate(90 773.3 8.63428)" fill="#F24C84" />
        <circle cx="773.3" cy="18.3979" r="1.5" transform="rotate(90 773.3 18.3979)" fill="#F24C84" />
        <circle cx="773.3" cy="28.1611" r="1.5" transform="rotate(90 773.3 28.1611)" fill="#F24C84" />
        <circle cx="773.3" cy="37.9243" r="1.5" transform="rotate(90 773.3 37.9243)" fill="#F24C84" />
        <circle cx="773.3" cy="47.6875" r="1.5" transform="rotate(90 773.3 47.6875)" fill="#F24C84" />
        <circle cx="773.3" cy="57.4507" r="1.5" transform="rotate(90 773.3 57.4507)" fill="#F24C84" />
        <circle cx="773.3" cy="67.2139" r="1.5" transform="rotate(90 773.3 67.2139)" fill="#F24C84" />
        <circle cx="773.3" cy="76.9771" r="1.5" transform="rotate(90 773.3 76.9771)" fill="#F24C84" />
        <circle cx="773.3" cy="86.7402" r="1.5" transform="rotate(90 773.3 86.7402)" fill="#F24C84" />
        <circle cx="773.3" cy="96.5039" r="1.5" transform="rotate(90 773.3 96.5039)" fill="#F24C84" />
        <circle cx="773.3" cy="106.267" r="1.5" transform="rotate(90 773.3 106.267)" fill="#F24C84" />
        <circle cx="773.3" cy="116.03" r="1.5" transform="rotate(90 773.3 116.03)" fill="#F24C84" />
        <circle cx="773.3" cy="125.793" r="1.5" transform="rotate(90 773.3 125.793)" fill="#F24C84" />
        <circle cx="773.3" cy="135.557" r="1.5" transform="rotate(90 773.3 135.557)" fill="#F24C84" />
        <circle cx="773.3" cy="145.32" r="1.5" transform="rotate(90 773.3 145.32)" fill="#F24C84" />
        <circle cx="773.3" cy="155.083" r="1.5" transform="rotate(90 773.3 155.083)" fill="#F24C84" />
        <circle cx="773.3" cy="164.846" r="1.5" transform="rotate(90 773.3 164.846)" fill="#F24C84" />
        <circle cx="773.3" cy="174.61" r="1.5" transform="rotate(90 773.3 174.61)" fill="#F24C84" />
        <circle cx="773.3" cy="184.373" r="1.5" transform="rotate(90 773.3 184.373)" fill="#F24C84" />
        <circle cx="773.3" cy="194.136" r="1.5" transform="rotate(90 773.3 194.136)" fill="#F24C84" />
        <circle cx="773.3" cy="203.899" r="1.5" transform="rotate(90 773.3 203.899)" fill="#F24C84" />
        <circle cx="773.3" cy="213.663" r="1.5" transform="rotate(90 773.3 213.663)" fill="#F24C84" />
        <circle cx="773.3" cy="223.426" r="1.5" transform="rotate(90 773.3 223.426)" fill="#F24C84" />
        <circle cx="773.3" cy="233.189" r="1.5" transform="rotate(90 773.3 233.189)" fill="#F24C84" />
        <circle cx="773.3" cy="242.952" r="1.5" transform="rotate(90 773.3 242.952)" fill="#F24C84" />
        <circle cx="773.3" cy="252.716" r="1.5" transform="rotate(90 773.3 252.716)" fill="#F24C84" />
        <circle cx="773.3" cy="262.479" r="1.5" transform="rotate(90 773.3 262.479)" fill="#F24C84" />
        <circle cx="773.3" cy="272.242" r="1.5" transform="rotate(90 773.3 272.242)" fill="#F24C84" />
        <circle cx="773.3" cy="282.005" r="1.5" transform="rotate(90 773.3 282.005)" fill="#F24C84" />
        <circle cx="773.3" cy="291.769" r="1.5" transform="rotate(90 773.3 291.769)" fill="#F24C84" />
        <circle cx="773.3" cy="301.532" r="1.5" transform="rotate(90 773.3 301.532)" fill="#F24C84" />
        <circle cx="773.3" cy="311.295" r="1.5" transform="rotate(90 773.3 311.295)" fill="#F24C84" />
        <circle cx="773.3" cy="321.059" r="1.5" transform="rotate(90 773.3 321.059)" fill="#F24C84" />
        <circle cx="773.3" cy="330.822" r="1.5" transform="rotate(90 773.3 330.822)" fill="#F24C84" />
        <circle cx="773.3" cy="340.585" r="1.5" transform="rotate(90 773.3 340.585)" fill="#F24C84" />
        <circle cx="773.3" cy="350.348" r="1.5" transform="rotate(90 773.3 350.348)" fill="#F24C84" />
        <circle cx="773.3" cy="360.111" r="1.5" transform="rotate(90 773.3 360.111)" fill="#F24C84" />
        <circle cx="773.3" cy="369.875" r="1.5" transform="rotate(90 773.3 369.875)" fill="#F04586" />
        <circle cx="773.3" cy="379.638" r="1.5" transform="rotate(90 773.3 379.638)" fill="#F04586" />
        <circle cx="773.3" cy="389.401" r="1.5" transform="rotate(90 773.3 389.401)" fill="#F04586" />
        <circle cx="773.3" cy="399.164" r="1.5" transform="rotate(90 773.3 399.164)" fill="#F04586" />
        <circle cx="773.3" cy="408.928" r="1.5" transform="rotate(90 773.3 408.928)" fill="#F04586" />
        <circle cx="773.3" cy="418.691" r="1.5" transform="rotate(90 773.3 418.691)" fill="#F04586" />
        <circle cx="773.3" cy="428.454" r="1.5" transform="rotate(90 773.3 428.454)" fill="#F04586" />
        <circle cx="773.3" cy="438.217" r="1.5" transform="rotate(90 773.3 438.217)" fill="#F04586" />
        <circle cx="773.3" cy="447.98" r="1.5" transform="rotate(90 773.3 447.98)" fill="#F04586" />
      </mask>
      <g mask="url(#mask2_2361_6810)">
        <rect x="728.8" y="-306.702" width="127" height="757.32" fill="url(#paint5_linear_2361_6810)" />
      </g>
      <path
        d="M225.5 383.902V348.335V348.335C225.5 347.874 225.874 347.5 226.335 347.5H261.111"
        stroke="url(#paint6_linear_2361_6810)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M609.405 347.5H645.016V347.5C645.478 347.5 645.852 347.874 645.852 348.336V383.067"
        stroke="url(#paint7_linear_2361_6810)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M645.853 730.98V766.547V766.547C645.853 767.009 645.479 767.382 645.018 767.382H610.241"
        stroke="url(#paint8_linear_2361_6810)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M261.947 767.382H226.336V767.382C225.875 767.382 225.5 767.008 225.5 766.547V731.815"
        stroke="url(#paint9_linear_2361_6810)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M438.5 312.5L438.5 272.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M438.366 804.538V844.538" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M685.5 557.5L755.5 557.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M191.5 558.123H121.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <g filter="url(#filter4_d_2361_6810)">
        <path
          d="M689.016 678.299C688.011 678.757 686.821 678.314 686.404 677.291C682.944 668.806 681.89 659.516 683.376 650.447C684.971 640.72 689.418 631.685 696.153 624.487C702.888 617.29 711.609 612.254 721.209 610.018C730.81 607.782 740.858 608.447 750.08 611.928C759.302 615.409 767.283 621.55 773.012 629.572C778.74 637.594 781.958 647.136 782.257 656.989C782.556 666.842 779.924 676.562 774.693 684.917C769.816 692.706 762.886 698.981 754.682 703.065C753.693 703.557 752.508 703.103 752.056 702.095L743.553 683.14C743.101 682.132 743.556 680.956 744.525 680.424C748.261 678.375 751.421 675.4 753.694 671.77C756.322 667.573 757.644 662.69 757.494 657.741C757.343 652.792 755.727 647.999 752.85 643.969C749.972 639.94 745.963 636.855 741.331 635.106C736.698 633.358 731.651 633.024 726.829 634.147C722.006 635.27 717.626 637.8 714.243 641.415C710.859 645.03 708.626 649.569 707.825 654.455C707.132 658.682 707.538 663.004 708.988 667.01C709.364 668.049 708.928 669.233 707.923 669.69L689.016 678.299Z"
          fill="url(#paint10_linear_2361_6810)"
          fillOpacity="0.6"
        />
        <path
          d="M750.054 702.939C750.46 703.966 749.957 705.132 748.914 705.496C739.068 708.935 728.387 709.194 718.385 706.237C717.325 705.923 716.767 704.783 717.122 703.737L723.846 683.959C724.201 682.913 725.336 682.362 726.407 682.633C730.803 683.743 735.42 683.631 739.757 682.309C740.813 681.987 741.974 682.482 742.379 683.51L750.054 702.939Z"
          fill="url(#paint11_linear_2361_6810)"
          fillOpacity="0.6"
        />
        <path
          d="M715.208 703.041C714.809 704.071 713.648 704.585 712.635 704.144C702.593 699.774 694.271 692.212 688.962 682.634C688.427 681.668 688.828 680.463 689.815 679.967L708.477 670.581C709.464 670.085 710.66 670.488 711.233 671.432C713.723 675.527 717.345 678.817 721.659 680.905C722.653 681.386 723.168 682.538 722.769 683.567L715.208 703.041Z"
          fill="url(#paint12_linear_2361_6810)"
          fillOpacity="0.6"
        />
      </g>
      <rect
        x="235.25"
        y="356.25"
        width="32.5"
        height="32.5"
        rx="1.25"
        stroke="url(#paint13_linear_2361_6810)"
        strokeWidth="1.5"
      />
      <rect
        x="606.25"
        y="727.25"
        width="32.5"
        height="32.5"
        rx="1.25"
        stroke="url(#paint14_linear_2361_6810)"
        strokeWidth="1.5"
      />
      <mask id="path-225-inside-6_2361_6810" fill="white">
        <path d="M438 341.5C438 339.291 439.791 337.496 442 337.536C486.948 338.355 530.597 352.959 567.019 379.421C603.44 405.883 630.818 442.883 645.486 485.378C646.207 487.466 645.054 489.724 642.953 490.407L567.38 514.962C565.279 515.644 563.029 514.492 562.283 512.412C553.339 487.481 537.089 465.783 515.61 450.179C494.132 434.574 468.475 425.824 442 425.022C439.792 424.955 438 423.171 438 420.961L438 341.5Z" />
      </mask>
      <path
        d="M438 341.5C438 339.291 439.791 337.496 442 337.536C486.948 338.355 530.597 352.959 567.019 379.421C603.44 405.883 630.818 442.883 645.486 485.378C646.207 487.466 645.054 489.724 642.953 490.407L567.38 514.962C565.279 515.644 563.029 514.492 562.283 512.412C553.339 487.481 537.089 465.783 515.61 450.179C494.132 434.574 468.475 425.824 442 425.022C439.792 424.955 438 423.171 438 420.961L438 341.5Z"
        fill="#694DBE"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-225-inside-6_2361_6810)"
      />
      <g filter="url(#filter5_d_2361_6810)">
        <circle
          cx="176.5"
          cy="471.5"
          r="42"
          fill="url(#paint15_linear_2361_6810)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2361_6810"
          x="238.755"
          y="358.485"
          width="407.99"
          height="406.029"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9" dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6810" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6810" result="shape" />
        </filter>
        <filter
          id="filter1_d_2361_6810"
          x="0"
          y="616.5"
          width="150"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6810" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6810" result="shape" />
        </filter>
        <filter
          id="filter2_d_2361_6810"
          x="648"
          y="792.5"
          width="147"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6810" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6810" result="shape" />
        </filter>
        <filter
          id="filter3_d_2361_6810"
          x="518"
          y="250.5"
          width="194"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6810" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6810" result="shape" />
        </filter>
        <filter
          id="filter4_d_2361_6810"
          x="682.721"
          y="608.721"
          width="107.559"
          height="107.559"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6810" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6810" result="shape" />
        </filter>
        <filter
          id="filter5_d_2361_6810"
          x="134.5"
          y="429.5"
          width="92"
          height="92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6810" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6810" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2361_6810"
          x1="-0.217733"
          y1="616.273"
          x2="167.284"
          y2="647.353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2361_6810"
          x1="647.787"
          y1="792.273"
          x2="811.978"
          y2="822.095"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2361_6810"
          x1="517.715"
          y1="250.273"
          x2="732.014"
          y2="302.357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2361_6810"
          x1="920.689"
          y1="405.604"
          x2="1027.69"
          y2="438.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2361_6810"
          x1="717.8"
          y1="615"
          x2="882.085"
          y2="665.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5A5A" stopOpacity="0" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2361_6810"
          x1="786.3"
          y1="-30.3825"
          x2="915.254"
          y2="9.56085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2361_6810"
          x1="225.445"
          y1="347.367"
          x2="268.627"
          y2="350.789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2361_6810"
          x1="609.349"
          y1="347.37"
          x2="653.518"
          y2="351.037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2361_6810"
          x1="610.187"
          y1="730.847"
          x2="653.368"
          y2="734.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2361_6810"
          x1="225.444"
          y1="731.685"
          x2="269.613"
          y2="735.352"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2361_6810"
          x1="750.96"
          y1="590.186"
          x2="802.837"
          y2="699.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2361_6810"
          x1="750.96"
          y1="590.186"
          x2="802.837"
          y2="699.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2361_6810"
          x1="750.96"
          y1="590.186"
          x2="802.837"
          y2="699.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2361_6810"
          x1="234.448"
          y1="355.376"
          x2="275.664"
          y2="358.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2361_6810"
          x1="605.448"
          y1="726.376"
          x2="646.664"
          y2="729.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2361_6810"
          x1="134.371"
          y1="429.193"
          x2="236.2"
          y2="437.443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
